import React from "react";
import NavigationBar from "../../../components/user/general/NavigationBar";
import HeroSection from "../../../subscreen/user/herosection/HeroSection";
// import SearchBar from "../search/SearchBar"
import CategoriesSection from "../categories/CategoriesSection";
import HowItWorks from "../howitwork/HowitWork";
import FeaturedDonors from "../FeatureDonation/FeaturedDonation";
import Footer from "../footer/Footer";
import LiveStatistics from "../livestatistics/LiveStatistics";
import Testimonials from "../testimonials/Testimonials";
   const Home = () =>{
    return(
     
        <>
         <NavigationBar/>
         <HeroSection/>
         {/* <SearchBar/> */}
         <CategoriesSection/>
         <HowItWorks/>
         <FeaturedDonors/>
         <LiveStatistics/>
         <Testimonials/>
         <Footer/>
        </>
    );
   }
export default Home;

